import React from 'react';
import ReactDOM from 'react-dom/client';
import config from 'devextreme/core/config';

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'devextreme/dist/css/dx.material.blue.dark.css';

config({ licenseKey: process.env.REACT_APP_DEVEXTREME_KEY });

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
